<template>
	<div class="orderInfo">
		<h3 class="orderInfo__title">Order Info</h3>
		<!--  -->
		
		<div class="input-group">
			<label class="input-group__label" for="">Customer: </label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder=""
				v-model="orderData.provider"
			/>
		</div>
		
		<div class="input-group">
			<label class="input-group__label" for="">EXT Ref Number: </label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="123456"
				v-model="orderData.external_ref"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Internal Number: </label>
			<input
				type="text"
				class="input-group__input red"
				name=""
				v-model="orderData.serial"
				readonly
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Sales Open Date / time: </label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="DD/MM/YY - HH:MM"
				v-model="orderData.sale_datetime"
			/>
		</div>

		<div class="orderInfo__spacer"></div>

		<div class="input-group">
			<label class="input-group__label" for="">Name:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="Full Customer Name"
				v-model="orderData.customer_name"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Street 1:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="Address Line 1"
				v-model="orderData.shipping_address_1"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Street 2:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="Address Line 2"
				v-model="orderData.shipping_address_2"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">City:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="City"
				v-model="orderData.shipping_address_3"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">State:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="City"
				v-model="orderData.shipping_address_4"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Postcode:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="PostCode"
				v-model="orderData.shipping_postcode"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Country Code:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder="Country Code"
				v-model="orderData.shipping_country_code"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Phone Number:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder=""
				v-model="orderData.phone"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Shipping Method:</label>
			<input
				type="text"
				class="input-group__input"
				name=""
				placeholder=""
				v-model="orderData.shipping_method"
			/>
		</div>

		<div class="input-group">
			<label class="input-group__label" for="">Order Color Tag:</label>
			<select name="" class="input-group__select">
				<option value="default">Default</option>
				<option value="default">Red - Address Issue</option>
				<option value="default">Purple - Hold on</option>
				<option value="default">Gold - VIP Order</option>
			</select>
		</div>

		<div class="orderInfo__buttons">
			<div class="submit-group">
				<button class="submit-group__btn submit-group__btn--lightRed" v-on:click="saveTerm()">
					<span>Save Edit</span>
				</button>
				<!-- <button class="submit-group__btn submit-group__btn--lightBlue">
					<span>Save</span>
				</button> -->
			</div>

			<div class="submit-group">
				<button class="submit-group__btn submit-group__btn--red" v-on:click="cancelOrder(orderData.serial)">
					<span>Cancel - ADMIN</span>
				</button>
				<button class="submit-group__btn submit-group__btn--blue">
					<span>UNDO - ADMIN</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
	name: "OrderInfo",
	components: {},
	props: {
		orderData: {
			type: Object
		}
	},
	methods: {
		saveTerm() {
			axios.post('https://new.colorwayrb.com/backend/editterm.php?sessionid=' + this.$store.getters.sessionid, this.orderData).then(response => {
				if (response.data.status == "OK") { 
					alert("Saved!");
				} else {
					alert("Error:" + response.msg );
				}
				//console.log(response);
				
			});
		},
		
		cancelOrder(order_serial) {
		
			if (confirm("Are you sure you want to cancel this order?")) {
				axios.get('https://new.colorwayrb.com/backend/ajax_cancel.php?sessionid=' + this.$store.getters.sessionid + '&order_serial=' + this.orderData.serial ).then(response => {
					
					alert("Cancelled!");
					
					
				});
			}
		},
		
		
	}
});
</script>

<style lang="scss" scoped>
.orderInfo {
	box-shadow: 1px 1px 1px $border-color;
	border: 1px solid rgba($border-color, 0.2);
	background-color: $color8;
	border-radius: 10px;
	padding: 20px;
	width: 400px;

	&__title {
		text-transform: uppercase;
		margin-bottom: 15px;
		text-align: center;
	}

	&__spacer {
		background-color: rgba($border-color, 0.15);
		margin: 5px 0 10px;
		border-radius: 5px;
		width: 100%;
		height: 2px;
	}

	&__buttons {
		padding-top: 10px;
	}
}

.input-group {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-bottom: 10px;

	&__label {
		text-transform: capitalize;
		font-size: 14px;
	}

	&__input {
		padding: 4px 10px;
		width: (185px - 20px);
		font-size: 14px;
		background-color: transparent;
		border: 1px solid rgba($border-color, 0.2);

		&::placeholder {
			color: black;
		}

		&.red {
			color: rgba($text-highlighter, 0.8);
			font-weight: 600;
			&::placeholder {
				color: rgba($text-highlighter, 0.8);
				font-weight: 600;
			}
		}
	}

	&__select {
		font-size: 14px;
		background-color: transparent;
		text-transform: uppercase;
		border: 1px solid $border-color;
		text-align-last: center;
		padding: 4px 0;
		width: 187px;
	}
}

.submit-group {
	padding: 5px;
	display: flex;
	justify-content: space-around;

	&__btn {
		width: 175px;
		height: 32px;

		display: flex;
		justify-content: center;
		align-items: center;

		box-shadow: 1px 1px 1px $border-color;
		cursor: pointer;
		text-transform: uppercase;
		font-weight: bold;
		border-radius: 5px;
		line-height: 16px;
		font-size: 12px;
		color: $color1;
		border: none;
	}

	&__btn--lightRed {
		background: rgba(214, 69, 69, 0.75);
	}

	&__btn--lightBlue {
		background: #9fb3c8;
	}

	&__btn--red {
		background: #d80027;
	}

	&__btn--blue {
		background: #0052b4;
	}
}
</style>